$(document).ready(function () {
    $(".reserver-button").click(function () {
        $('.validation-retrait').css('display', 'block');
    });
});